export default class AnchorHelper {
    setup() {
        // Remove a tags without href
        document.querySelectorAll('a:not([href])').forEach(anchor => {
            const parent = anchor.parentNode;
            while (anchor.firstChild) {
                parent.insertBefore(anchor.firstChild, anchor);
            }
            parent.removeChild(anchor);
        });
    }
}